// input-number-auto-size.directive.ts
import { AfterViewInit, Directive, Host, input, OnChanges } from "@angular/core";
import { isNil } from "lodash";
import { InputNumber } from "primeng/inputnumber";

@Directive({ selector: "p-inputnumber[inputSize]", standalone: true })
export class InputNumberSizeFixDirective implements AfterViewInit, OnChanges {
  protected readonly inputSize = input.required<number>();

  constructor(@Host() private readonly component: InputNumber) {}

  ngAfterViewInit(): void {
    this.apply();
  }

  ngOnChanges(): void {
    this.apply();
  }

  private apply(): void {
    const input = this.component.input?.nativeElement;
    if (isNil(input)) {
      return;
    }

    const size = Math.max(0, Math.floor(this.inputSize()));
    input.setAttribute("size", String(size));
  }
}
